import { Navigate, useParams } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { useI18n } from "../i18n";
import { usePub, useHead } from "./PublicSite";

const DOCS = ["terms", "privacy", "cookies"];
const UPDATED = "2026-11-01";

export const Legal = () => {
  const { doc } = useParams();
  const { pt, lang, content, en } = usePub();
  const { fmtDate } = useI18n();
  const ok = DOCS.includes(doc);
  useHead(pt(`meta.${ok ? doc : "terms"}_title`), pt("meta.legal_desc"));
  if (!ok) return <Navigate to={`/${lang}/`} replace />;
  const sections = (content.legal || en.legal)[doc];
  const keys = Object.keys(sections).filter((k) => k.endsWith("_t"));
  return (
    <div className="pub-section" data-testid={`legal-${doc}`}>
      <article className="pub-wrap pub-article">
        <h1 className="pub-h1 pub-h1-sm">{pt(`footer.${doc}`)}</h1>
        <p className="pub-muted">{pt("legal.updated", { date: fmtDate(UPDATED, false) })}</p>
        <p className="pub-legal-note" role="note" data-testid="legal-review-note"><AlertTriangle className="h-4 w-4 shrink-0" /><span>{pt("legal.notice")}</span></p>
        {keys.map((k) => <section key={k}><h2 className="pub-h3">{sections[k]}</h2><p className="pub-prose">{sections[k.replace(/_t$/, "_b")]}</p></section>)}
        {doc === "cookies" && <button type="button" className="pub-btn pub-btn-dark mt-6" onClick={() => window.dispatchEvent(new Event("am:cookie-reopen"))} data-testid="cookie-change-choice-button">{pt("legal.change_choice")}</button>}
      </article>
    </div>
  );
};
